import React from 'react';
import styles from '../../styles/CrLoadingOverlay.module.scss';
import { Overlay } from '@fluentui/react/lib/Overlay';
import { Spinner, SpinnerSize } from '@fluentui/react/lib/Spinner';

export interface ICrLoadingOverlayProps {
    isLoading: boolean;
    opaque?: boolean;
    style?: any;
}

export const CrLoadingOverlay = ({ isLoading, opaque, style }: ICrLoadingOverlayProps): React.ReactElement => {
    return isLoading && (
        <Overlay style={style || {}} className={`${styles.crLoadingOverlay} ${opaque && styles.opaque}`}>
            <Spinner size={SpinnerSize.large} label="Loading..." />
        </Overlay>
    );
};
